export default __webpack_public_path__ + "static/media/43.57b4702a.jpg";